<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col>
          <h2>Edição de {{ this.$gui.batch }}</h2>

          <b-alert :variant="feedback.type" dismissible :show="feedback.show" fade
            @dismissed="feedback.show=false">
              {{ feedback.data }}
          </b-alert>

          <b-alert variant="warning" class="" :show="!batchCanBeUpdated">
            <p class="m-0 text-center">Nome, valor e limite máximo de validações não podem ser alterados neste lote pois já existem ingressos gerados.</p>
          </b-alert>

          <b-form @submit.prevent="updateBatch">
            <b-form-group
              :description="this.$gui.batchesExample">
                <p class="mb-2 font-weight-bold">Nome do {{ $gui.batchLC }}</p>
                <b-form-input
                  type="text"
                  v-model.trim="form.name"
                  required
                  :disabled="!batchCanBeUpdated">
                </b-form-input>
            </b-form-group>

            <b-form-group
              description="Exemplo: R$ 30,00">
              <p class="mb-2 font-weight-bold">Valor do {{ $gui.batchLC }}</p>
              <b-input-group prepend="R$">
                  <money required class="form-control"
                    v-model="form.value" v-bind="money"
                    :disabled="!batchCanBeUpdated">
                  </money>
              </b-input-group>
            </b-form-group>

            <b-form-group
              v-if="this.$gui.isEvento"
              description="O intervalo entre validações do mesmo ingresso é de 6 horas.">

              <p class="mb-2 font-weight-bold">Limite máximo de validações</p>
              <b-form-select
                v-model.number="form.max_validations"
                :options="maxValidationsOptions"
                :disabled="!batchCanBeUpdated">
              </b-form-select>
            </b-form-group>

            <b-form-group>
              <p class="mb-2 font-weight-bold">Estoque do {{ $gui.batchLC }}</p>

              <b-form-checkbox
                v-model="unlimitedStock" switch>
                {{ unlimitedStock ? 'Estoque ilimitado ativado' : 'Estoque ilimitado desativado' }}
              </b-form-checkbox>

              <b-form-select class="mt-3" v-model="stockAction" :options="stockActions" v-if="unlimitedStock === false" @change="setFocus">
              </b-form-select>

              <b-form-group class="mt-4 mb-0" v-if="unlimitedStock === false && ['add', 'sub'].includes(stockAction)">
                <b-input-group>
                  <template #prepend>
                    <b-input-group-text >{{ stockLabel }}</b-input-group-text>
                  </template>
                  <b-form-input type="number" v-model.number="form.stock" style="text-align: center" ref="inputStock"></b-form-input>
                  <template #append>
                    <b-input-group-text >unidades</b-input-group-text>
                  </template>
                </b-input-group>
              </b-form-group>

              </b-form-group>

            <b-form-group
              :description="'A Loja Virtual só aceita compras deste ' + $gui.batchLC + ' em múltiplos deste número. Use 1 para permitir qualquer quantidade.'">
              <p class="mb-2 font-weight-bold">Mínimo de unidades por venda</p>
              <b-form-input type="number" min="1" max="30" step="1" v-model.number="form.min_sale_amount"></b-form-input>
            </b-form-group>

            <b-form-group v-if="event && event.categories_enabled === 1">
              <p class="mb-2 font-weight-bold">Categoria</p>
              <b-form-select v-model="form.category_id" :options="categoryOptions"></b-form-select>
            </b-form-group>

            <b-button type="submit" variant="primary" class="mt-3">Editar {{ this.$gui.batchLC }}</b-button>
          </b-form>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import {Money} from 'v-money'

export default {
  name: 'OrganizerBatchEdit',
  components: {
    Money
  },
  data () {
    return {
      batchId: parseInt(this.$route.params.id),
      organizer: this.$route.params.organizer,
      event: '',
      feedback: {
        data: '',
        type: '',
        show: false
      },
      form: {
        id: 0,
        name: '',
        value: '',
        max_validations: 1,
        min_sale_amount: 1,
        stock: null,
        category_id: null
      },
      categories: [],
      stockAction: '',
      stockActions: [
        {value: '', text: 'Selecione uma ação'},
        {value: 'add', text: 'Adicionar unidades'},
        {value: 'sub', text: 'Remover unidades'},
        {value: 'reset', text: 'Zerar estoque'},
      ],
      unlimitedStock: true,
      batchCanBeUpdated: false,
      maxValidationsOptions: [
        { value: 1, text: '1 - Uma vez' },
        { value: 2, text: '2 - Duas vezes' },
        { value: 3, text: '3 - Três vezes' },
        { value: 4, text: '4 - Quatro vezes' },
        { value: 5, text: '5 - Cinco vezes' },
      ],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2
      }
    }
  },
  mounted () {
    this.getBatch(this.batchId)
  },
  methods: {
    getBatch (batchId) {
      let url = process.env.VUE_APP_URL_APP + '/b/organizers/' + this.organizer + '/events'
      return this.$http.get(url).then(res => {
        this.event = res.body
        let i = this.$_.findIndex(res.body.batches, b => b.id === batchId)
        let batch = res.body.batches[i]
        this.form.id = batchId
        this.form.name = batch.name
        this.form.value = batch.value / 100
        this.form.max_validations = batch.max_validations
        this.form.min_sale_amount = batch.min_sale_amount || 1
        this.form.category_id = batch.category_id || null
        this.unlimitedStock = batch.stock === null
        this.batchCanBeUpdated = batch.print_amount === 0 || this.$gui.isFicha
        if (res.body.categories_enabled === 1) {
          this.loadCategories()
        }
      }, err => {
        console.log(err)
      })
    },
    updateBatch () {
      if (!(Number.isInteger(this.form.min_sale_amount) && this.form.min_sale_amount >= 1 && this.form.min_sale_amount <= 30)) {
        this.feedback.data = 'O mínimo de unidades por venda deve ser um número inteiro de 1 a 30.'
        this.feedback.type = 'danger'
        this.feedback.show = true
        return false
      }

      let i = this.$_.findIndex(this.event.batches, b => b.id === this.form.id)
      let batch = this.event.batches[i]
      let value = Math.round(this.form.value * 100)
      let data = {}

      if (batch.name !== this.form.name) {
        data.name = this.form.name
      }

      if (batch.value !== value) {
        data.value = value
      }

      if (batch.max_validations !== this.form.max_validations) {
        data.max_validations = this.form.max_validations
      }

      if (batch.min_sale_amount !== this.form.min_sale_amount) {
        data.min_sale_amount = this.form.min_sale_amount
      }

      if (this.stockAction === 'sub') {
        this.form.stock *= -1
      } else if (this.stockAction === 'reset') {
        this.form.stock = 0
      }

      let changedStock = (batch.stock === null && ((['add', 'sub'].includes(this.stockAction) && this.form.stock !== null) || this.stockAction === 'reset'))
        || (batch.stock !== null && ((['add', 'sub'].includes(this.stockAction) && this.form.stock !== null) || this.stockAction === 'reset'))
        || (batch.stock !== null && this.unlimitedStock)

      if (changedStock) {
        data.stock = this.unlimitedStock ? null : this.form.stock
      }

      if (batch.category_id !== this.form.category_id) {
        data.category_id = this.form.category_id
      }

      if (this.$_.isEmpty(data)) {
        this.$router.go(-1)
        return
      }

      data.user_agent = navigator.userAgent

      let url = process.env.VUE_APP_URL_APP + '/b/organizers/' + this.organizer + '/batches/' + this.form.id

      this.$http.put(url, data).then(res => {
        let i = this.$_.findIndex(this.event.batches, b => b.id === this.form.id)

        this.event.batches[i].name = res.body.name
        this.event.batches[i].value = res.body.value
        this.event.batches[i].max_validations = res.body.max_validations
        this.event.batches[i].min_sale_amount = res.body.min_sale_amount
        this.event.batches[i].stock = res.body.stock

        this.form.id = 0
        this.form.name = ''
        this.form.value = 0
        this.form.max_validations = 1
        this.form.min_sale_amount = 1
        this.form.stock = null

        this.$router.go(-1)
      }, err => {
        this.feedback.data = err.body.message
        this.feedback.type = 'danger'
        this.feedback.show = true
        console.log(err)
      })
    },
    async loadCategories () {
      try {
        const url = process.env.VUE_APP_URL_APP + `/b/organizers/${this.organizer}/categories`
        const resp = await this.$http.get(url)
        this.categories = resp.body.categories || []
      } catch (err) {
        console.error(err)
      }
    },
    setFocus (value) {
      if (['add', 'sub'].includes(value)) {
        this.$refs.inputStock.focus()
      }
    }
  },
  computed: {
    categoryOptions () {
      const opts = [{ value: null, text: 'Sem categoria' }]
      for (const c of this.categories) {
        opts.push({ value: c.id, text: `${c.emoji} ${c.category}` })
      }
      return opts
    },
    stockLabel () {
      switch (this.stockAction) {
        case 'add':
          return 'Adicionar'
        case 'sub':
          return 'Remover'
        default:
          return ''
      }
    }
  }
}
</script>
